import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [visible, setVisible] = useState([false, false, false, false, false, false, false]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log('Sending email with data:', formData);
    
    try {
      const response = await fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'api-key': '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',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          sender: { email: 'info@manami-trading.com', name: 'Manami Trading Website' },
          to: [{ email: 'info@manami-trading.com' }],
          replyTo: { email: formData.email, name: formData.name },
          subject: `New Contact Form Message from ${formData.name}`,
          htmlContent: `
            <h2>New Contact Form Submission</h2>
            <p><strong>Name:</strong> ${formData.name}</p>
            <p><strong>Email:</strong> ${formData.email}</p>
            <p><strong>Message:</strong></p>
            <p>${formData.message}</p>
          `
        })
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok) {
        console.log('✓ Email sent successfully!');
        setShowSuccess(true);
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setShowSuccess(false), 5000);
      } else {
        console.error('Failed to send email:', data);
        setShowError(true);
        setTimeout(() => setShowError(false), 5000);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setShowError(true);
      setTimeout(() => setShowError(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    [0, 1, 2, 3, 4, 5, 6].forEach((i) => {
      setTimeout(() => {
        setVisible(prev => {
          const newVisible = [...prev];
          newVisible[i] = true;
          return newVisible;
        });
      }, i * 150);
    });
  }, []);

  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 50%, rgba(71, 85, 105, 0.85) 100%), url("https://images.unsplash.com/photo-1542838132-92c53300491e?w=1600&q=80") center/cover',
      padding: '140px 0 100px',
      position: 'relative',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center'
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at top right, rgba(59, 130, 246, 0.15) 0%, transparent 50%)',
      pointerEvents: 'none'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: 800,
      color: '#ffffff',
      marginBottom: '20px',
      textShadow: '0 4px 12px rgba(0,0,0,0.3)',
      letterSpacing: '-0.02em'
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: '#e2e8f0',
      maxWidth: '700px',
      margin: '0 auto',
      lineHeight: 1.6
    }
  };

  return (
    <>
      {showSuccess && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: '#10b981',
          color: 'white',
          padding: '16px 24px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 9999,
          fontSize: '1rem',
          fontWeight: '500'
        }}>
          ✓ Email sent successfully! We'll get back to you soon.
        </div>
      )}
      {showError && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: '#ef4444',
          color: 'white',
          padding: '16px 24px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 9999,
          fontSize: '1rem',
          fontWeight: '500'
        }}>
          ✗ Failed to send email. Please try again.
        </div>
      )}
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row>
            <Col className="text-center">
              <h1 style={styles.heroTitle}>Contact Us</h1>
              <p style={styles.heroSubtitle}>
                Get in Touch - We would love to hear from you. Contact us for product inquiries, partnerships, or general information.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <div style={{ backgroundColor: '#f5f5f5', padding: '80px 0' }}>
        <Container>
          <Row className="align-items-center">
            {/* Left Side - Contact Form */}
            <Col lg={6} className="mb-4 mb-lg-0">
            <div style={{ 
              backgroundColor: 'white', 
              borderRadius: '24px', 
              padding: '60px 50px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              opacity: visible[0] ? 1 : 0,
              transform: visible[0] ? 'translateY(0)' : 'translateY(30px)',
              transition: 'all 0.6s ease'
            }}>
              <h2 style={{ 
                fontSize: '2rem', 
                fontWeight: 'bold', 
                marginBottom: '20px',
                color: '#000'
              }}>
                Send us a Message
              </h2>
              <p style={{ 
                color: '#666', 
                marginBottom: '40px',
                fontSize: '1rem'
              }}>
                Feel free to contact us any time. We will get back to you as soon as we can!
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '12px 0',
                      border: 'none',
                      borderBottom: '1px solid #ddd',
                      fontSize: '1rem',
                      outline: 'none',
                      backgroundColor: 'transparent'
                    }}
                  />
                </div>

                <div className="mb-4">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '12px 0',
                      border: 'none',
                      borderBottom: '1px solid #ddd',
                      fontSize: '1rem',
                      outline: 'none',
                      backgroundColor: 'transparent'
                    }}
                  />
                </div>

                <div className="mb-4">
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    style={{
                      width: '100%',
                      padding: '12px 0',
                      border: 'none',
                      borderBottom: '1px solid #ddd',
                      fontSize: '1rem',
                      outline: 'none',
                      resize: 'none',
                      backgroundColor: 'transparent'
                    }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    width: '100%',
                    padding: '16px',
                    backgroundColor: isSubmitting ? '#94a3b8' : '#2563eb',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50px',
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    marginTop: '20px',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseEnter={(e) => !isSubmitting && (e.target.style.backgroundColor = '#1d4ed8')}
                  onMouseLeave={(e) => !isSubmitting && (e.target.style.backgroundColor = '#2563eb')}
                >
                  {isSubmitting ? 'Sending...' : 'Send'}
                </button>
              </form>
            </div>
            </Col>

            {/* Right Side - Contact Info */}
            <Col lg={6}>
            <div style={{ position: 'relative' }}>
              {/* Blue decorative blocks */}
              <div style={{
                position: 'absolute',
                top: '-30px',
                right: '0',
                width: '160px',
                height: '120px',
                backgroundColor: '#3b82f6',
                borderRadius: '12px',
                zIndex: 0,
                opacity: visible[1] ? 1 : 0,
                transform: visible[1] ? 'scale(1)' : 'scale(0.8)',
                transition: 'all 0.5s ease'
              }}></div>

              <div style={{
                position: 'absolute',
                bottom: '-30px',
                right: '0',
                width: '160px',
                height: '120px',
                backgroundColor: '#2563eb',
                borderRadius: '12px',
                zIndex: 0,
                opacity: visible[2] ? 1 : 0,
                transform: visible[2] ? 'scale(1)' : 'scale(0.8)',
                transition: 'all 0.5s ease'
              }}></div>

              {/* Contact Info Card */}
              <div style={{
                backgroundColor: '#2D2D2D',
                borderRadius: '24px',
                padding: '50px 40px',
                position: 'relative',
                zIndex: 1,
                marginRight: '80px',
                opacity: visible[3] ? 1 : 0,
                transform: visible[3] ? 'translateY(0)' : 'translateY(30px)',
                transition: 'all 0.6s ease'
              }}>
                <h2 style={{
                  color: 'white',
                  fontSize: '2rem',
                  fontWeight: 'bold',
                  marginBottom: '40px'
                }}>
                  Contact Info
                </h2>

                {/* Phone */}
                <div className="d-flex align-items-start mb-4" style={{
                  opacity: visible[4] ? 1 : 0,
                  transform: visible[4] ? 'translateX(0)' : 'translateX(-20px)',
                  transition: 'all 0.5s ease'
                }}>
                  <div style={{ marginRight: '20px', marginTop: '5px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" fill="white"/>
                      <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.086-1.391l-4.064-3.696z" fill="white"/>
                    </svg>
                  </div>
                  <div>
                    <p style={{ color: 'white', margin: 0, fontSize: '1.1rem' }}>
                      +264 811 406 099<br />
                      +264 857 802 221
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="d-flex align-items-start mb-4" style={{
                  opacity: visible[5] ? 1 : 0,
                  transform: visible[5] ? 'translateX(0)' : 'translateX(-20px)',
                  transition: 'all 0.5s ease'
                }}>
                  <div style={{ marginRight: '20px', marginTop: '5px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z" fill="white"/>
                    </svg>
                  </div>
                  <div>
                    <p style={{ color: 'white', margin: 0, fontSize: '1.1rem' }}>
                      info@manami-trading.com
                    </p>
                  </div>
                </div>

                {/* Location */}
                <div className="d-flex align-items-start mb-4" style={{
                  opacity: visible[6] ? 1 : 0,
                  transform: visible[6] ? 'translateX(0)' : 'translateX(-20px)',
                  transition: 'all 0.5s ease'
                }}>
                  <div style={{ marginRight: '20px', marginTop: '5px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="white"/>
                    </svg>
                  </div>
                  <div>
                    <p style={{ color: 'white', margin: 0, fontSize: '1.1rem', lineHeight: '1.6' }}>
                      Windhoek, Namibia
                    </p>
                  </div>
                </div>

                {/* Social Media */}
                <div style={{
                  opacity: visible[6] ? 1 : 0,
                  transform: visible[6] ? 'translateX(0)' : 'translateX(-20px)',
                  transition: 'all 0.5s ease'
                }}>
                  <h4 style={{ color: 'white', fontSize: '1.2rem', marginBottom: '16px' }}>Follow Us</h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z"/>
                        <circle cx="16.806" cy="7.207" r="1.078"/>
                        <path d="M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 0 0-2.184.42 4.6 4.6 0 0 0-2.633 2.632 6.585 6.585 0 0 0-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 0 0 2.186-.419 4.613 4.613 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 0 0-.421-2.217zm-1.218 9.532a5.043 5.043 0 0 1-.311 1.688 2.987 2.987 0 0 1-1.712 1.711 4.985 4.985 0 0 1-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 0 1-1.669-.311 2.985 2.985 0 0 1-1.719-1.711 5.08 5.08 0 0 1-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 0 1 .311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 0 1 1.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 0 1 1.67.311 2.991 2.991 0 0 1 1.712 1.712 5.08 5.08 0 0 1 .311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z"/>
                      </svg>
                      <span style={{ color: '#e2e8f0', fontSize: '0.95rem' }}>Manami Trading CC / Kalahari Foods_NA</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
                      </svg>
                      <span style={{ color: '#e2e8f0', fontSize: '0.95rem' }}>Manami Trading CC / Kalahari Foods_NA</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"/>
                      </svg>
                      <span style={{ color: '#e2e8f0', fontSize: '0.95rem' }}>Manami Trading CC / Kalahari Foods_NA</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Contact;